import { ConvertOutcome } from '../models/convert-outcome';

/**
 * Runs one conversion after the other and collects what came of them (#2166).
 *
 * Turning one document into several is several calls. They have to run under
 * one bracket: if the third fails, the first two exist regardless, and saying
 * only "error" leaves the reader with new documents they were never shown and
 * cannot find. So nothing stops early, and what was created is carried out
 * alongside the fact that something went wrong.
 */
export const runConversions = async <T>(
    transitions: T[],
    run: (transition: T) => void | Promise<ConvertOutcome | void>
): Promise<ConvertOutcome> => {
    const collected: ConvertOutcome = { created: [], failed: false };

    for (const transition of transitions) {
        const result = await run(transition);

        if (!result) {
            continue;
        }

        collected.created.push(...result.created);
        collected.failed = collected.failed || result.failed;
    }

    return collected;
};
